<template>
  <div class="wlx-stu-manager-wrapper">
    <div class="u-school-manager-head stu-manager-head-con clearfix">
      <router-link :to="{name:'AuthenStandard'}" class="head-link-a">申请标准</router-link>
      <router-link :to="{name:'stuExamCheck'}" class="head-link-a">学员考证审核</router-link>
      <router-link :to="{name:'siteInfoTest'}" class="head-link-a">站点考核信息审核</router-link>
      <router-link :to="{name:'siteTrainCheck'}" class="head-link-a">站点培训信息审核</router-link>
      <!-- <router-link :to="{name:'AuthenNode'}" class="head-link-a">认证节点</router-link> -->
    </div>
    <div class="u-table-main">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import StudentIndexManage from "page/xSchool/manager/StudentIndexManage.vue";
export default {
  data() {
    return {};
  },
  components: {
    StudentIndexManage
  }
};
</script>

<style lang="scss">
.wlx-stu-manager-wrapper {
  .stu-manager-head-con {
    text-align: left;
    .head-link-a {
      float: left;
      padding: 0 20px;
      text-align: center;
      height: 60px;
      line-height: 60px;
      font-size: 16px;
      color: #000;
    }
    .head-link-a:hover {
      color: #409eff;
    }
    .linkActive {
      border-bottom: 2px solid #409eff;
      color: #409eff;
    }
  }
}
</style>
